import { async } from '@angular/core/testing';
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Datasource

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
//import {KhoXuatKhoEditComponent } from '../kho-xuat-kho-edit/kho-xuat-kho-edit.component';
//import {KhoXuatKhoDuyetComponent } from '../kho-xuat-kho-duyet/kho-xuat-kho-duyet.component';
import { environment } from '../../../../../../../environments/environment';
//Model

import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { roundWithPrecision } from 'chartist';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { KhoXuatKhoPageDataSource } from '../../kho-xuat-kho-page/kho-xuat-kho-page-datasource/kho-xuat-kho.datasource';
import {KhoXuatKhoChiTiet } from '../../kho-xuat-kho-page/kho-xuat-kho-page-model/kho-xuat-kho-page.model';
import { KhoXuatKhoPageService } from '../../kho-xuat-kho-page/kho-xuat-kho-page-service/kho-xuat-kho-page.service';
import { KhoDeNghiXuatKhoPageService } from '../kho-de-nghi-xuat-kho-page-service/kho-de-nghi-xuat-kho-page.service';
import { KhoDeNghiXuatKhoPageDataSource } from '../kho-de-nghi-xuat-kho-page-datasource/kho-de-nghi-xuat-kho-page.datasource';
import { KeHoachGiaoHangFilterChoGiao } from '../kho-de-nghi-xuat-kho-page-model/kho-de-nghi-xuat-kho-page.model';
import { KhoDeNghiXuatKhoChiTiet } from '../../../chuc-nang-kho/kho-de-nghi-xuat-kho/kho-de-nghi-xuat-kho-model/kho-de-nghi-xuat-kho.model';
import { TokenStorage } from 'app/core/auth/_services';

@Component({
	selector: 'm-list-don-hang-ban-ct',
	templateUrl: './list-don-hang-ban-ct.component.html',
	styleUrls: ['../kho-de-nghi-xuat-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})
export class ListDonHangBanCtComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	
	// Table fields
	dataSource:KhoDeNghiXuatKhoPageDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
			stt: 1,
			name: 'MAHANG',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'TENHANG',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 4,
            name: 'QUYCACH',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 3,
            name: 'DVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 12,
            name: 'SOLUONG',
            displayName: 'Số lượng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'SOLUONGDAGIAO',
            displayName: 'Số lượng đã giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'NGAYGIAOHANG',
            displayName: 'Ngày giao hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'GHICHU',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		
		{
            stt: 9,
            name: 'LOAIPHIEU',
            displayName: 'Loại phiếu ĐNXK',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'SOPHIEUDHB',
            displayName: 'Số phiếu ĐHB',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'MAKH',
            displayName: 'Mã KH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'TENKH',
            displayName: 'Tên KH',
            alwaysChecked: false,
			isShow: true
		},
	];

	@ViewChildren('focus') focus ;
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	@ViewChild('searchFullText', {static: true}) searchFullText: ElementRef;
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;

	// Filter fields
	// @ViewChild('searchTuNgay', {static: true}) searchTuNgay: ElementRef;
	// @ViewChild('searchDenNgay', {static: true}) searchDenNgay: ElementRef;
	minDate: string = "";
	maxDate: string = "";
	@ViewChild('keywordSearch', {static: true}) keywordSearch: ElementRef;
	isZoomSize: boolean = false;
	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selectionPDN = new SelectionModel<KeHoachGiaoHangFilterChoGiao>(true, []);

	KhoXuatKhoResult:KeHoachGiaoHangFilterChoGiao[] = [];
	tmpKhoXuatKhoResult:KeHoachGiaoHangFilterChoGiao[] = [];
	listDDHDaChon:KhoXuatKhoChiTiet[] = [];
	dsDDHDaChon:KeHoachGiaoHangFilterChoGiao[] = [];

	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	viewLoading: boolean = false;

	saveNewTTHV: number[] = []
	flagHighlight: boolean = false;

	previousIndex: number;
	fixedPoint = 2;
	__back = true;

	isXuatDiXuLy: boolean = false;

	//ROLES
	// TAO = 131;
	// SUA = 132;
	// XOA = 133;
	// CHI_TIET = 134
	// KIEM_TRA = 135

	LIST_ROLES_USER : [] = [];

	// SHOW_BUTTON_CREATE = new BehaviorSubject<boolean>(false);
	// SHOW_BUTTON_EDIT = new BehaviorSubject<boolean>(false);
	// SHOW_BUTTON_DELETE = new BehaviorSubject<boolean>(false);
	// SHOW_BUTTON_DETAIL = new BehaviorSubject<boolean>(false);
	// SHOW_BUTTON_CHECK = new BehaviorSubject<boolean>(false);

	list = new BehaviorSubject<KeHoachGiaoHangFilterChoGiao>(new KeHoachGiaoHangFilterChoGiao());

	//filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};

	IdNCC = '';
	isChange: boolean = false;
	saveAddedTTHV: number[] = [];

	checkAllRecord: boolean =  false;
	listHangHoaDaChon:KeHoachGiaoHangFilterChoGiao[] = [];

	allRecordSelect :KeHoachGiaoHangFilterChoGiao[] = [];

	showAll: boolean = false;
	edit: boolean = false;

	actionDialogDenghi: boolean = false;
	danhSachId = [];

	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key == "Escape") {
			this.back();
		}
	}

	constructor(
		private service:KhoDeNghiXuatKhoPageService,
		public dialog2: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private tokenStorage: TokenStorage,
		public dialogRef2: MatDialogRef<ListDonHangBanCtComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private layoutUtilsService: LayoutUtilsService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.LIST_ROLES_USER = user.roles;
		}
	/** LOAD DATA */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;

		//this.selectionPDN.clear();
		this.danhSachId = this.data.danhSachId;
		
		//this.getNumberRecordHoanTat();

		//this.dsDDHDaChon = this.data.list;
		this.dialogRef2.keydownEvents().subscribe(event => {
			if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.TIEPTUC.KeyCombine.keycode && this.listHangHoaDaChon.length > 0){
				this.addPhieuDeNghiCT();
			}
		});

		this.haveFilter = true;

		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadListDHB();
					this.forcusEvents();
				})
			)
			.subscribe();

		this.showColumnsInTable();
		this.applySelectedColumns();

		// Init DataSource
		this.dataSource = new KhoDeNghiXuatKhoPageDataSource(this.service);

		this.dataSource.entitySubject.subscribe(res => {
			this.KhoXuatKhoResult = res;
			this.tmpKhoXuatKhoResult = []
			if(this.KhoXuatKhoResult != null){
				for(let i = 0; i < this.KhoXuatKhoResult.length; i++){
					let tmpElement = new KeHoachGiaoHangFilterChoGiao();
					tmpElement.copy(this.KhoXuatKhoResult[i])
					this.tmpKhoXuatKhoResult.push(tmpElement);

					this.tmpKhoXuatKhoResult = [...this.tmpKhoXuatKhoResult];
					this.tmpKhoXuatKhoResult.forEach(x => {
						let index = this.danhSachId.findIndex(a => a == x.Id_CT);
						if( index > -1){
							this.listHangHoaDaChon.push(x);
						}

						if(this.listHangHoaDaChon.findIndex(a => a.Id_CT == x.Id_CT) > -1){
							this.selectionPDN.select(x);
						}
					});
					this.changeDetect.detectChanges();
				}
			}
		});
		this.loadListDHB();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);
	}

	
	ngAfterViewInit() {
		// this.focus.first.nativeElement.focus();
		this.changeDetect.detectChanges();
    }

	isTrueButton(ROLENUMBER: number){
		if(this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1){
			return true;
		}
		return false;
	}

	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}

	/** SELECTION */
	// isAllSelected() {
	// 	let numSelected = this.listHangHoaDaChon.length;
	// 	let numRows = this.allRecordSelect.length;
	// 	return numSelected == numRows;
	// }

	//  /** Selects all rows if they are not all selected; otherwise clear selection. */
	// masterToggle(event) {
	// 	if(event.checked){
	// 		this.selectionPDN.clear();
	// 		this.listHangHoaDaChon = this.allRecordSelect.map(x => x);
	// 		this.allRecordSelect.forEach(x => {
	// 			this.selectionPDN.selected.push(x);
	// 		});
	// 		this.changeDetect.detectChanges();
	// 	}else{
	// 		this.selectionPDN.clear();
	// 		this.listHangHoaDaChon = [];
	// 		this.changeDetect.detectChanges();
	// 	}
	// }

	/** SELECTION */
	isAllSelected() {
		const numSelected = this.selectionPDN.selected.filter(x => this.danhSachId.findIndex(a => a == x.Id) == -1).length;
		const numRows = this.tmpKhoXuatKhoResult.filter(x => this.danhSachId.findIndex(a => a == x.Id) == -1).length;
		return numSelected === numRows;
	}
	 /** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		if (this.isAllSelected()) {
			this.selectionPDN.selected.filter(x => this.danhSachId.findIndex(a => a == x.Id_CT) == -1).forEach(row => {
				let index = this.listHangHoaDaChon.findIndex(x => x.Id_CT == row.Id_CT);
				if( index > -1){
					this.listHangHoaDaChon.splice(index, 1);
				}
				this.selectionPDN.deselect(row);
			});
			
		} else {
			this.tmpKhoXuatKhoResult.filter(x => this.danhSachId.findIndex(a => a == x.Id_CT) == -1).forEach(row => {
				this.selectionPDN.select(row);
				if(this.listHangHoaDaChon.findIndex(x => x.Id_CT == row.Id_CT) == -1){
					this.listHangHoaDaChon.push(row);
				}
			});
		}
	}

	// loadKhoXuatKhoDSDN(showAll: boolean = false) {
	// 	const queryParams = new QueryParamsModel(
	// 		this.filterConfiguration(showAll),
	// 		this.sort.direction,
	// 		this.sort.active,
	// 		0,
	// 		10,
	// 		this.filterGroupData,
	// 		true
	// 	);
	// 	this.dataSource.loadKhoXuatKhoDNs(queryParams);
	// }

	loadListDHB() {
		this.selectionPDN.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadListDonHangBanCts(queryParams);
	}

	loadListDHBFirstPage() {
		this.selectionPDN.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadListDonHangBanCts(queryParams);
	}

	/** FILTRATION */
	filterConfiguration(): any {
		const filter: any = {};
		return filter;
	}

	/** ACTIONS */
	/** Delete */
	// deletePhieuKhoXuatKho(_item:KhoXuatKho) {
	// 	const _title: string = 'Xóa phiếu thông tin hàng về';
	// 	const _description: string = 'Bạn có chắc muốn xóa phiếu thông tin hàng về không?';
	// 	const _waitDesciption: string = 'Phiếu thông tin hàng về đang được xóa...';
	// 	const _deleteMessage = `Phiếu thông tin hàng về đã được xóa`;
	// 	const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);

	// 	dialogRef.afterClosed().subscribe(res => {
	// 		this.forcusEvents();
	// 		if (!res) {
	// 			return;
	// 		}
	// 		this.KhoXuatKhoService.detailOrder(_item.IdXk).subscribe(res => {
	// 			if (res && res.status === 1) {
	// 				this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete, 3000,true,false);
	// 			}
	// 			else {
    //                 this.layoutUtilsService.showActionNotification(res.error.message, MessageType.Delete);
    //             }
	// 			this.loadKhoXuatKhoDSDN();
	// 		});
	// 	});
	// }

	//Apply selected Column
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}

	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}

    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}

	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}

	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}

	dropListDropped(event: CdkDropList, column: string) {
		;
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}

	f_convertDate(v: any = "") {
		let a = v === "" ? new Date() : new Date(v);
		return a.getFullYear() + "-" + ("0" + (a.getMonth() + 1)).slice(-2) + "-" + ("0" + (a.getDate())).slice(-2) + "T00:00:00.0000000";
	}

	minMaxDate(p_Val: any, flag?: number) {
		if (flag == 0) //tu ngay dang selected
			this.minDate = this.f_convertDate(p_Val._d);
		else
			this.maxDate = this.f_convertDate(p_Val._d);
		let d1 = new Date(this.minDate);
		let d2 = new Date(this.maxDate);
		if (d1.getTime() > d2.getTime())
			this.maxDate = this.f_convertDate(d1.getDate() + 1);

		this.loadListDHB();
	}





	ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}

	getNameOfTinhTrang(tinhtrang: number){
		if(tinhtrang == 0)
			return 'Chưa duyệt';
		else if(tinhtrang == 1)
			return 'Đã duyệt';
		else if(tinhtrang == 2)
			return 'Không duyệt';
		else if(tinhtrang == 4)
			return 'Chờ kiểm tra';
		else if(tinhtrang == 5)
			return 'Đang kiểm tra';
		else if(tinhtrang == 6)
			return 'Đã kiểm tra';
		return '';
	}

	canDeleteOrUpdate(item: any){
		if(item != undefined && item.Tinhtrang != 1 && item.Tinhtrang!= 5 && item.Tinhtrang != 6)
			return true;
		return false
	}

	asyncCanDeleteOrUpdate(item: any){
		if(this.canDeleteOrUpdate(item))
			return new BehaviorSubject<boolean>(true);
		return new BehaviorSubject<boolean>(false);
	}

	forcusEvents(){
		if(this.focus != null && this.focus != undefined){
			// this.focus.first.nativeElement.focus();
			this.changeDetect.detectChanges();
		}
	}

	public onKeydownMain(event :KeyboardEvent) {
		//Tham khảo keyCode của event theo link: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
		// if (event.altKey && event.keyCode == 78) {
		// 	this.addPhieuKhoXuatKho();
		// }
	}

	//Filter on Grid
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}

	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}

	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	filterHead(col) {
		if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
			for(var elementFake of this.filterGroupDataCheckedFake[col]){
				let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id)
				if(index > -1)
					this.filterGroupDataChecked[col][index].checked = elementFake.checked;
			}
			this.filterGroupData[col] = [];
			this.filterGroupArray[col] = [];
			this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
				.filter(opt => opt.checked);
			this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
				.filter(opt => opt.checked).map(op => op.value);
		}
		this.filterText = Object.assign({}, this.tmpfilterText);
		if (this.filterText) {
			this.filterConfiguration();
		}
		this.loadListDHB();
		this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		this.tmpfilterText[col] = '';
	}
	remove(item, col) {
		;
		let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
		if (_index > -1) {
			this.filterGroupDataChecked[col][_index].checked = false;
			this.filterGroupData[col] = [];
			this.filterGroupArray[col] = [];
			this.filterGroupArray[col] = this.filterGroupDataChecked[col]
				.filter(opt => opt.checked);
			this.filterGroupData[col] = this.filterGroupDataChecked[col]
				.filter(opt => opt.checked).map(op => op.value);

			if(this.filterGroupData[col] != null && this.filterGroupData[col].length == 0){
				this.filterGroupData[col] = null
			}
			this.loadListDHB();
		}
	}
	removeText(col){
		this.filterText[col]="";
		this.loadListDHB();
		this.forcusEvents();
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key]="";
			}
		}
		this.loadListDHB();
		this.forcusEvents();
	}
	checkFilterHasValue(data, col) {
		let _count = 0;
		if(col=='ALL'&&data){//check all column
			for (var key in data) {
				if (data.hasOwnProperty(key)) {
					if (data[key]) {
						let _arrflt = data[key].filter(opt => opt.checked);
						_count += _arrflt ? _arrflt.length : 0;
					}
				}
			}
			let _text="";
			for (var key in this.filterText) {
				if (this.filterText.hasOwnProperty(key)) {
					_text+=this.filterText[key];
				}
			}
			if (_count > 0||_text) {
				return true;
			}
		}
		else{//check in 1 column
			if (data&&data[col]) {
				let _arrflt = data[col].filter(opt => opt.checked);
				_count += _arrflt ? _arrflt.length : 0;
			}
			if (_count > 0) {
				return true;
			}
		}
		return false;
	}

	filterGroupWithTextFilter(columnName: string){
		;
		let search = this.tmpfilterText[columnName]

		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}

		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
																ts => ts.name.toLowerCase().indexOf(search) > -1)

		this.changeDetect.detectChanges();
	}

	getTitle(){
		return 'KẾ HOẠCH GIAO HÀNG KHÁCH HÀNG';
	}

	back(__action: boolean = false){

		let tmp : KhoDeNghiXuatKhoChiTiet[] = [];
		if(__action){
			this.listHangHoaDaChon.forEach(x => {
				if(this.danhSachId.findIndex(a => a == x.Id) == -1){
					let item = new KhoDeNghiXuatKhoChiTiet();
					item.IdHh = x.Id_HH;
					item.MaHH = x.MaHH;
					item.TenHH = x.TenHH;
					item.QuyCach = x.QuyCach;
					item.Dvt = x.DVT;
					item.TenDvt = x.TenDVT;
					item.Soluong = x.SoLuong - x.SoLuongDaGiao;
					item.NgayCan = x.NgayGiaoHang;
					item.MucDichSuDung = "";
					item.SLThucXuat = 0.00;
					item.TenBPDN = "";
					item.TenBPSD = "";
					item.DatHangId = x.Id_DHB;
					item.DatHangCtId = x.Id_CT;
					item.DatHangSoPhieu = x.SoPhieu_DHB;
					tmp.push(item);
				}
			});
		}
		this.dialogRef2.close({
			action: __action,
			list: tmp
		});
	}

	checkIdDSDN(tmp: any, id: any){

		let isTrue = false;
		tmp.forEach(x => {
			if(+x == id){
				isTrue = true;
			}
		});
		return isTrue;
	}

	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case false:
				return 'pdnmh_dahuy';
			case true:
				return 'pdnmh_success';
			default:
				return 'success';
		}
	}

	setDisabled(item: any){
		if(item.TinhTrang == 'KHOPDNXK_CHODUYET'){
			return false;
		}
		return true;
	}

	addPhieuDeNghiCT(){
		if(this.listHangHoaDaChon.length == 0){
			const message = 'Vui lòng chọn hàng hóa từ danh sách bên dưới.';
			this.layoutUtilsService.showErorr(message);
			return;
		}
		this.back(true);
	}

	mergeArr(arr1: any, arr2: any){

	}

	// isChecked(row: any){
	// 	let index = this.listHangHoaDaChon.findIndex(x => x.IdHH == row.IdHH && x.Id == row.Id);
	// 	if(index > -1){
	// 		this.selectionPDN.select(row);
	// 	}else{
	// 		this.selectionPDN.deselect(row);
	// 	}
	// 	return index > -1;
	// }

	// selectionPDNToggle(event, row: any){
	// 	this.selectionPDN.toggle(row);
	// 	if(event.checked){
	// 		this.listHangHoaDaChon.push(row);
	// 	}else{
	// 		let ind = this.listHangHoaDaChon.findIndex(x => x.IdHH == row.IdHH  && x.Id == row.Id);
	// 		if(ind > -1){
	// 			this.listHangHoaDaChon.splice(ind,1);
	// 		}
	// 	}
	// }

	disableSLTon(row: any){
		
		if(row.SLTon == 0 || row.SLTon == null) return true;
		return false;
	}

	showAllList(event){
		if(event.checked){
			this.showAll = true;
		}else{
			this.showAll = false;
		}
		this.loadListDHB();
		this.changeDetect.detectChanges();
	}

	isDisableAll(){
		for(let i = 0; i < this.allRecordSelect.length; i++){
			if(this.disableSLTon(this.allRecordSelect[i]) == false){
				return false;
			}
		}
		return true;
	}

	toggleRow(row: KeHoachGiaoHangFilterChoGiao){
		
		this.selectionPDN.toggle(row);
		var isChecked  = this.selectionPDN.isSelected(row);
		if(isChecked){
			if(this.listHangHoaDaChon.findIndex(a => a.Id_CT == row.Id_CT) == -1)
				this.listHangHoaDaChon.push(row);
		}else{
			let index =this.listHangHoaDaChon.findIndex(a => a.Id_CT == row.Id_CT);
			if( index > -1)
				this.listHangHoaDaChon.splice(index, 1);
		}
		this.changeDetect.detectChanges();
	}

	disabledRow(row: KeHoachGiaoHangFilterChoGiao){
		return this.danhSachId.findIndex(x => x == row.Id) > -1;
	}

	disabledAllRow(){
		let count = 0;
		this.selectionPDN.selected.forEach(x => {
			if(this.disabledRow(x)){
				count++;
			}
		})
		return count == this.tmpKhoXuatKhoResult.length;
	}

	selectionPDNHasValue(){
		return this.selectionPDN.hasValue() && this.selectionPDN.selected.filter(x => this.danhSachId.findIndex(a => a == x.Id_CT) == -1).length > 0;
	}

	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
}
